var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ACommentIcon"},[_c('a-router-link-issue-detail',{attrs:{"go-to-tab":_vm.commentsRoute,"unique-item-name":_vm.uniqueItemName}},[_c('message-square-icon',{attrs:{"size":"14"}}),_vm._v(" "+_vm._s(_vm.commentCount ? 'x' + _vm.commentCount : '')+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }